import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialGrid from "../../../../__snowpack__/pkg/@mui/material/Grid.js";
import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React, {useCallback, useEffect, useState} from "react";
import Button from "../../atoms/button/button.component.js";
import MergeUnitEmptyState from "../merge-unit-empty-state/merge-unit-empty-state.component.js";
import MergeSuggestionItem from "../merge-suggestion-item/merge-suggestion-item.component.js";
import {MergeSuggestionsListContainer, MergeSuggestionsListTitleContainer, MergeUnitEmptyStateContainer} from "./merge-suggestions-list.styles.js";
function MergeSuggestionsList({
  pairs,
  mergeQueue,
  onQueue,
  onQueueAll
}) {
  const {
    t
  } = useTranslation();
  const parsePairs = useCallback((p) => {
    return p.filter(([pSrc, pDst]) => {
      const exist = mergeQueue.some(([src, dst]) => {
        const inSrc = src?.id === pSrc?.id && pSrc;
        const inDst = dst?.id === pDst?.id && pDst;
        return inSrc && inDst;
      });
      return !exist;
    });
  }, [mergeQueue]);
  const [parsedPairs, setParsedPairs] = useState(() => parsePairs(pairs));
  useEffect(() => {
    setParsedPairs(parsePairs(pairs));
  }, [pairs, parsePairs]);
  const handleQueueAll = useCallback(() => {
    if (onQueueAll) {
      onQueueAll(parsedPairs);
    }
  }, [onQueueAll, parsedPairs]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true
  }, /* @__PURE__ */ React.createElement(MergeSuggestionsListTitleContainer, null, /* @__PURE__ */ React.createElement(MaterialTypography, {
    variant: "h5"
  }, t("units.mergeSuggestions")), /* @__PURE__ */ React.createElement(Button, {
    onClick: handleQueueAll,
    variant: "text",
    color: "secondary",
    disabled: !parsedPairs.length
  }, t("units.queueAll")))), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true
  }, /* @__PURE__ */ React.createElement(MergeSuggestionsListContainer, {
    elevation: 1
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    container: true,
    spacing: 1,
    direction: "column",
    alignItems: "center"
  }, parsedPairs.length ? parsedPairs.map((pair) => /* @__PURE__ */ React.createElement(MaterialGrid, {
    key: pair.map(({
      id
    }) => id).join("-"),
    item: true,
    xs: 12,
    style: {
      width: "100%"
    }
  }, /* @__PURE__ */ React.createElement(MergeSuggestionItem, {
    pair,
    onQueue
  }))) : /* @__PURE__ */ React.createElement(MergeUnitEmptyStateContainer, null, /* @__PURE__ */ React.createElement(MergeUnitEmptyState, {
    icon: "help_outline",
    content: t("units.mergeSuggestionEmptyState"),
    direction: "column"
  }))))));
}
export default /* @__PURE__ */ React.memo(MergeSuggestionsList);
